module.exports = "function setup() {\n  createCanvas(200, 200)\n}\n\nfunction draw() {\n  background(220)\n}\n"


//////////////////
// WEBPACK FOOTER
// ./~/raw-loader!./lib/default-sketch.js
// module id = 182
// module chunks = 0